import { makeStyles, Theme } from "@material-ui/core/styles";
import { secondary } from "../../../../../infrastructure/theme/customColors";

interface Props {
  totalItems?: number;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  downloadButtonContainer: {
    cursor: "pointer",
    pointerEvents: ({ totalItems }) => (totalItems === 0 ? "none" : "auto"),
    marginLeft: "auto",
  },
  donwloadLabel: {
    fontSize: "13px",
    fontWeight: 400,
    marginRight: theme.spacing(1),
    color: secondary,
  },
  containerLoader: {
    height: "119px",
    marginBottom: theme.spacing(3),
  },
  backLabel: {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
